import {Transaction} from "../models/Transaction";
import GTable from "../libs/gtable/GTable";
import { ETransactionType } from "../shared/ITransaction";
import { Cols, ITransaction, IValue } from "../shared/Consts";
import TableUtils from "../portlibs/TableUtils";
import PortUtils from "../portlibs/PortUtils";
import PortPref from "../portlibs/PortPref";
import { OpenAddHolding } from "../dialogs/AddHolding";
import Holding from "../models/Holding";
import { TSorter } from "../libs/gtable/GTableConsts";

function className(trans:ITransaction&IValue,col:string,isCash:boolean) {
    if (col==Cols.date || col==Cols.maturity) return "no-break"
    else if (col==Cols.type || col==Cols.total) switch(trans.type) {
        case ETransactionType.buy:       return (trans.quantity>0 && !isCash) ||(trans.quantity<0 && isCash) ? "red bold" : "teal bold"
        case ETransactionType.dividend:
        case ETransactionType.interest:  return "green"
        case ETransactionType.reinvest:
        case ETransactionType.topup:     return "orange"
        case ETransactionType.adjust:    return trans.quantity < 0 ? "orange" : "green"
    }
    else return PortUtils.cellClass(col, (trans as any)[col])
}

export type TValueGetter = (row:Transaction, col:string) => string
export interface ITransTableProps {
    classNames?:Record<string,any>
    tableName:string
    cols:string[]
    rows:Transaction[]
    footer?:any
    infiniteScroll?:boolean
    holding?:Holding
    value?:TValueGetter
    sorter?:TSorter<Transaction>
}

export default function TransactionTable(props:ITransTableProps){
    const {tableName,footer,infiniteScroll,...tableProps} = props
    const isCash = props.holding?.isCash || false
    const updateTransaction = OpenAddHolding()
    const cell = (row:Transaction, col:string) => props.value ? props.value(row, col) : row.value(col)
    const cellProp = (row:Transaction, col:string) => ( {className:className(row,col,isCash), align:TableUtils.align(col)} )
    const headerProps = (col:string) => ({align:TableUtils.align(col)})
    const sorter = (col:string, dir:number) => props.sorter ? props.sorter(col, dir) : PortUtils.transSorter(col, dir)
    const row = (row:Transaction) => ({onClick:() => updateTransaction(row, row.holding)})
    const footers : any[] = []
    if (footer) footers.push(footer)
    return <GTable tableName={tableName} {...tableProps} footers={footer ? [footer] : undefined} userPref={PortPref.i}
        infiniteScroll={infiniteScroll} rowKey={(row:Transaction) => row.id} 
        bodyCell={cell} bodyCellProps={cellProp} bodyRowProps={row}
        headerCell={TableUtils.header} headerCellProps={headerProps} sorter={sorter}
    />
}
